import _ from 'underscore';
import { isMobileDevice } from '../../../../services/CordovaService/NetworkConnectionService';
import { parseRefText, NonStringDataObj } from './TextWithReferences.logic';

type Props = {
    text: string;
};

const TextWithReferences = (props: Props) => {
    const content = parseRefText(props.text);

    const getMatchingTypeByItemType = (item: NonStringDataObj) => {
        switch (item.type) {
            case 'Variable':
                let className = 'formdata-field';
                let value = item.value || '(Feld leer)';
                return <span className={className}>{value}</span>;
            case 'Link':
                const onLinkClicked = () => {
                    window.open(item.href, '_system'); // dedicated onclick function to open url in system browser of mobile devices
                    return false;
                };
                return <a 
                    href={isMobileDevice() ? undefined : item.href}     // prevent opening the link in cordova web view on mobile
                    onClick={isMobileDevice() ? onLinkClicked : undefined}
                    style={{
                        color: 'var(--color-primary)',
                        textDecoration: 'underline'
                    }}  // dedicated style since link is not blue and underlined if no href
                >
                    {item.title}
                </a>;
            case 'Style':
                switch (item.style) {
                    case 'bold':
                        return <b>{item.text}</b>;
                    case 'italic':
                        return <i>{item.text}</i>;
                    case 'underlined':
                        return <span className="text-underlined">{item.text}</span>;
                    case 'strikethrough':
                        return <span className="text-strikethrough">{item.text}</span>;
                    case 'red':
                        return <span className="text-red">{item.text}</span>;
                    case 'green':
                        return <span className="text-green">{item.text}</span>;
                    case 'primary-color':
                        return <span className="text-primary-color">{item.text}</span>;
                    default: return item.text;
                }
            case 'Newline':
                return <br />;
            default:
                return <span>UNKNOWN ITEM TYPE</span>;
        }
    };

    const matchingElements = _.map(content, (item, index) => {
        switch (typeof item) {
            case 'string':
                return <span key={index}>{item}</span>;
            case 'object':
                return <span key={index}>{getMatchingTypeByItemType(item)}</span>;
            default:
                return <span key={index}>UNKNOWN ITEM TYPE</span>;
        }
    });

    return <>{matchingElements}</>;
};

export default TextWithReferences;